(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bv-toiletry-v2"]) return;
  try {
    
if (!customElements.get('bv-toiletry-v2')) {
  customElements.define('bv-toiletry-v2', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      this.strings = JSON.parse(this.querySelector('[data-strings]').textContent);
      this.thumbs = [...this.querySelectorAll('.t2-thumb')];
      this.index = 0;
      this.colour = this.dataset.colour;
      this.preview = this.dataset.preview === 'true';
      this.form = this.querySelector('.t2-form');
      this.lightbox = this.querySelector('.t2-lightbox');
      this.cartDialog = this.querySelector('.t2-cart-confirmation');
      this.mainImage = this.querySelector('.t2-main-image');
      this.addEventListener('click', event => this.onClick(event), {signal:this.abort.signal});
      this.addEventListener('change', event => {
        if (event.target.matches('[data-variant-colour]')) this.setColour(event.target.dataset.variantColour);
      }, {signal:this.abort.signal});
      this.form.addEventListener('submit', event => this.addToBag(event), {signal:this.abort.signal});
      this.lightbox.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {event.preventDefault();this.showImage(this.index + (event.key === 'ArrowRight' ? 1 : -1));}
      }, {signal:this.abort.signal});
      let touchStart;
      this.querySelector('.t2-stage').addEventListener('pointerdown', event => {if(event.pointerType === 'touch') touchStart = event.clientX;}, {signal:this.abort.signal});
      this.querySelector('.t2-stage').addEventListener('pointerup', event => {
        if (touchStart == null) return;
        const distance = event.clientX - touchStart; touchStart = null;
        if (Math.abs(distance) > 50) {this.swiped = true;this.showImage(this.index + (distance < 0 ? 1 : -1));}
      }, {signal:this.abort.signal});
      this.querySelectorAll('dialog').forEach(dialog => dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if(event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
      }, {signal:this.abort.signal}));
      this.observer = new IntersectionObserver(entries => {
        const entry = entries[0];
        this.querySelector('[data-sticky]').hidden = entry.isIntersecting || entry.boundingClientRect.bottom > 0;
      }, {threshold:0});
      this.observer.observe(this.form);
      this.setColour(this.colour, false);
    }
    disconnectedCallback() {this.abort?.abort();this.observer?.disconnect();this.ready = false;}
    onClick(event) {
      const target = event.target.closest('button');
      if (!target || !this.contains(target)) return;
      if (target.hasAttribute('data-index')) this.showImage(Number(target.dataset.index));
      if (target.hasAttribute('data-prev')) this.showImage(this.index - 1);
      if (target.hasAttribute('data-next')) this.showImage(this.index + 1);
      if (target.hasAttribute('data-zoom')) {if(this.swiped){this.swiped=false;return;}this.showImage(this.index);this.lightbox.showModal();}
      if (target.hasAttribute('data-close')) target.closest('dialog').close();
      if (target.hasAttribute('data-inside')) {this.showImage(1);this.lightbox.showModal();}
      if (target.hasAttribute('data-choose')) {
        const radio = this.querySelector('[data-variant-colour="'+target.dataset.choose+'"]');
        if(radio){radio.checked=true;radio.dispatchEvent(new Event('change',{bubbles:true}));this.form.scrollIntoView({block:'center',behavior:this.motion()});radio.focus({preventScroll:true});}
      }
      if (target.hasAttribute('data-quantity')) {
        const input = this.form.querySelector('[name="quantity"]');
        input.value = Math.max(1,Math.min(99,(parseInt(input.value,10)||1) + Number(target.dataset.quantity)));
      }
    }
    motion() {return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';}
    setColour(colour, updateUrl = true) {
      const input = this.querySelector('[data-variant-colour="'+colour+'"]');
      if (!input) return;
      input.checked=true;this.colour = colour;this.dataset.colour = colour;
      this.thumbs.forEach(button => {const image = button.querySelector('img');const url = new URL(button.dataset[colour],this.baseURI);url.searchParams.set('width','200');image.srcset='';image.src=url.href;image.alt=this.strings[colour]+' — '+button.dataset.caption;});
      this.querySelectorAll('.t2-colour-image').forEach(image => {
        const url = new URL(image.dataset[colour],this.baseURI);url.searchParams.set('width','1200');image.src=url.href;image.srcset='';
      });
      this.querySelector('[data-price]').textContent=input.dataset.money;
      this.querySelector('[data-sticky-price]').textContent=input.dataset.money;
      this.querySelector('[data-sticky-finish]').textContent=this.strings[colour];
      this.available=this.preview||input.dataset.available==='true';
      this.querySelector('[data-stock]').textContent=this.preview?this.strings.dispatch:this.available?this.strings.inStock:this.strings.soldOut;
      this.setBusy(false);this.showImage(this.index);
      this.querySelector('[data-error]').hidden=true;
      if (updateUrl && location.pathname.includes('/products/')) {const url = new URL(location.href);url.searchParams.set('variant',input.value);history.replaceState({},'',url);}
    }
    showImage(index) {
      this.index=(index+this.thumbs.length)%this.thumbs.length;
      const current=this.thumbs[this.index];
      this.thumbs.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===this.index)));
      const source=current.dataset[this.colour];
      this.mainImage.srcset='';this.mainImage.src=source;this.mainImage.alt=this.strings[this.colour]+' — '+current.dataset.caption;
      const zoom=this.querySelector('[data-zoom-image]');zoom.src=source;zoom.alt=this.mainImage.alt;
      this.querySelectorAll('[data-gallery-caption]').forEach(node=>node.textContent=current.dataset.caption);
      this.querySelector('[data-gallery-counter]').textContent=(this.index+1)+' / '+this.thumbs.length;
    }
    setBusy(busy) {
      this.busy=busy;
      this.querySelectorAll('[data-add]').forEach(button=>{button.disabled=busy||!this.available;button.setAttribute('aria-busy',String(busy));});
      this.querySelectorAll('[data-add-label]').forEach(label=>label.textContent=busy?this.strings.adding:this.available?(this.preview?this.strings.previewAdd:this.strings.add):this.strings.soldOut);
      this.querySelectorAll('[data-variant-colour]').forEach(input=>input.disabled=busy);
    }
    async addToBag(event) {
      event.preventDefault();if(this.busy||!this.available)return;
      const error=this.querySelector('[data-error]');error.hidden=true;
      if(!this.form.reportValidity())return;
      const data=new FormData(this.form);const addedColour=this.colour;const quantity=Number(data.get('quantity'));
      this.setBusy(true);
      try {
        if (!this.preview) {
        const response=await fetch(this.dataset.addUrl,{method:'POST',headers:{Accept:'application/json'},body:data});
        const result=await response.json();
        if(!response.ok) throw new Error(result.description||this.strings.error);
        }
        this.querySelector('[data-added-finish]').textContent=this.strings[addedColour];
        this.querySelector('[data-added-quantity]').textContent=this.strings.quantity+': '+quantity;
        const image=this.querySelector('[data-added-image]');image.src=this.thumbs[0].dataset[addedColour];image.alt=this.strings[addedColour];
        this.cartDialog.showModal();
      } catch (failure) {error.textContent=failure.message||this.strings.error;error.hidden=false;error.scrollIntoView({block:'center',behavior:this.motion()});}
      finally {this.setBusy(false);}
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
